import React from 'react'
import { Typography } from '@mui/material'
import { black } from '../../../../../colors'
import { type IAttribute } from '../../../../../models/Attributes'
import CustomTooltip from '../../../../../components/CustomTooltip'
import { useFormContext } from 'react-hook-form'
import MultiSelectApiAutoComplete from '../../../../../components/FormElements/MultiSelectApiAutoComplete'

interface SlicesSectionProps {
  name: string
}

const SlicesSection: React.FC<SlicesSectionProps> = ({ name }) => {
  const { watch } = useFormContext()
  const maxSlices = 5
  const selectedSlices = (watch(name) || [])
  const canAddMore = selectedSlices.length < maxSlices

  return (
    <>
      <Typography color={black[100]} fontWeight={700}>Slice Data</Typography>
      <CustomTooltip title={!canAddMore ? `You can only add up to ${maxSlices} slices` : ''}>
        <MultiSelectApiAutoComplete
          apiEndpoint="/api/attributes/values/"
          apiExtraParams={{ attributeType: 'Course Attributes', pageSize: 20 }}
          label='Attributes'
          placeholder="Select Attributes"
          name={name}
          getOptionLabel={((option: IAttribute) => option.attributeValue ?? '')}
          getOptionValue={((option: IAttribute) => option.attributeValueId ?? '')}
          getOptionSubLabel={((option: IAttribute) => option.attributeKey)}
          renderTagsType='chips'
          getOptionDisabled={(option: IAttribute) => !canAddMore && !selectedSlices.some((s: IAttribute) => s.attributeValueId === option.attributeValueId)}
        />
      </CustomTooltip>
    </>
  )
}

export default SlicesSection
